import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconVacationHome = forwardRef((props, ref) => _jsxs(Container, {
  "data-testid": "IconVacationHome",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: [_jsx("path", {
    d: "M17.9 8.13a2.06 2.06 0 1 0 0-4.13 2.06 2.06 0 0 0 0 4.13m-2.67 7.44h1.33v1.33h-1.33zm-2.41-7.22a1.4 1.4 0 0 1 1.86 0l.37.33V7.51a3.5 3.5 0 0 0-6.92-.7c.53.8 1.46 2.38 1.86 4.06z"
  }), _jsx("path", {
    d: "M19.53 19.06h-.64V14.6l.3.27a.47.47 0 0 0 .66-.04.47.47 0 0 0-.04-.67l-1.37-1.21v-2.43a.47.47 0 1 0-.94 0v1.6l-3.44-3.07a.5.5 0 0 0-.62 0l-5.75 5.11a.47.47 0 0 0 .62.7l.3-.26v4.46h-1.5V17q.3-.09.57-.3v-.83a1.4 1.4 0 0 1-.61-2.42l2.11-1.87C8.82 9.3 7.09 6.94 7.01 6.83a.47.47 0 0 0-.75 0c-.09.13-2.23 3.06-2.23 5.53 0 1.2.24 2.35.68 3.22Q5.3 16.74 6.17 17v2.05h-1.7a.47.47 0 0 0-.47.47c0 .25.2.46.47.47h15.06a.47.47 0 1 0 0-.94M14.3 15.1c0-.26.2-.47.46-.47h2.26c.26 0 .47.2.47.46v2.27c0 .26-.2.47-.47.47h-2.26a.47.47 0 0 1-.46-.47zm-2.57 3.95v-3.49h-.93v3.49h-.94V15.1c0-.26.21-.47.47-.47h1.87c.26 0 .47.2.47.46v3.96z"
  })]
}));
IconVacationHome.displayName = 'IconVacationHome';